/**
 * Observer Ranch — optional publisher credit on The Observer Review Volume 1.
 * Skip = book only (Dawn product-form). Accept = one /cart/add.js items[] call.
 * No-op when [data-or-print-credits] is absent (offer ends after 2026-09-20 shop TZ).
 * Collection ATC intercept lives in card-product while the offer is active.
 */
(function () {
  const SUPPORTER_SKUS = ['OR-PRINT-10', 'OR-PRINT-25', 'OR-PRINT-100', 'OR-PRINT-250'];
  const SUPPORTER_IDS = ['54559598936288', '54559599755488', '54561500463328', '54561500496096'];
  const NAME_PROP = 'Name in printed credits';

  function cartAddUrl() {
    return (window.routes && window.routes.cart_add_url) || '/cart/add';
  }

  function cartJsUrl() {
    const u = (window.routes && window.routes.cart_url) || '/cart';
    return u.replace(/\/$/, '') + '.js';
  }

  document.addEventListener('change', function (e) {
    const t = e.target;
    if (!t || t.name !== 'or_print_credits') return;
    const root = t.closest('[data-or-print-credits]');
    if (!root) return;
    const nameWrap = root.querySelector('[data-or-print-credits-name]');
    const input = root.querySelector('[data-or-print-credits-name-input]');
    const on = Boolean(t.value);
    if (nameWrap) nameWrap.hidden = false;
    if (input) {
      input.toggleAttribute('required', on);
      if (!on) input.removeAttribute('required');
    }
  });

  document.addEventListener(
    'submit',
    function (evt) {
      const form = evt.target;
      if (!(form instanceof HTMLFormElement)) return;

      const credits = form.querySelector('[data-or-print-credits]');
      if (!credits) return;

      const idInput = form.querySelector('[name="id"]');
      const variantId = idInput ? String(idInput.value) : '';

      const chosen = credits.querySelector('input[name="or_print_credits"]:checked');
      const supporterId = chosen && chosen.value;
      if (!supporterId) return;

      evt.preventDefault();
      evt.stopImmediatePropagation();

      const nameInput = credits.querySelector('[data-or-print-credits-name-input]');
      const name = ((nameInput && nameInput.value) || '').trim();
      if (!name) {
        if (nameInput) {
          nameInput.setAttribute('required', 'required');
          nameInput.reportValidity();
          nameInput.focus();
        }
        return;
      }

      addBookAndCredits(form, variantId, supporterId, name);
    },
    true
  );

  async function addBookAndCredits(form, bookVariantId, supporterId, name) {
    const productForm = form.closest('product-form');
    const submitButton = productForm && productForm.querySelector('[type="submit"]');
    const spinner = productForm && productForm.querySelector('.loading__spinner');
    const errorWrap = productForm && productForm.querySelector('.product-form__error-message-wrapper');
    const errorMsg = productForm && productForm.querySelector('.product-form__error-message');

    if (submitButton) {
      submitButton.setAttribute('aria-disabled', 'true');
      submitButton.classList.add('loading');
    }
    if (spinner) spinner.classList.remove('hidden');
    if (errorWrap) errorWrap.setAttribute('hidden', '');

    const qtyInput = form.querySelector('[name="quantity"]');
    const qty = parseInt(qtyInput && qtyInput.value, 10) || 1;
    const cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    try {
      const cart = await fetch(cartJsUrl(), { credentials: 'same-origin' }).then(function (r) {
        return r.json();
      });
      const hasSupporter = (cart.items || []).some(function (item) {
        return (
          SUPPORTER_SKUS.indexOf(item.sku) !== -1 ||
          SUPPORTER_IDS.indexOf(String(item.id)) !== -1 ||
          SUPPORTER_IDS.indexOf(String(item.variant_id)) !== -1
        );
      });

      const items = [{ id: Number(bookVariantId), quantity: qty }];
      if (!hasSupporter) {
        const props = {};
        props[NAME_PROP] = name;
        items.push({ id: Number(supporterId), quantity: 1, properties: props });
      }

      const payload = { items: items };
      if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
        payload.sections = cartEl.getSectionsToRender().map(function (s) {
          return s.id;
        });
        payload.sections_url = window.location.pathname;
      }

      const response = await fetch(cartAddUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
        },
        credentials: 'same-origin',
        body: JSON.stringify(payload),
      }).then(function (r) {
        return r.json();
      });

      if (response.status) {
        const msg = response.description || response.message || 'Could not add to cart';
        if (errorWrap && errorMsg) {
          errorWrap.removeAttribute('hidden');
          errorMsg.textContent = msg;
        }
        return;
      }

      if (!cartEl) {
        window.location = (window.routes && window.routes.cart_url) || '/cart';
        return;
      }
      if (cartEl.classList.contains('is-empty')) cartEl.classList.remove('is-empty');
      cartEl.renderContents(response);
    } catch (err) {
      console.error(err);
      if (errorWrap && errorMsg) {
        errorWrap.removeAttribute('hidden');
        errorMsg.textContent = (err && err.message) || 'Could not add to cart';
      }
    } finally {
      if (submitButton) {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
      }
      if (spinner) spinner.classList.add('hidden');
    }
  }
})();
